import { render, staticRenderFns } from "./OfficePage.vue?vue&type=template&id=27629eef&scoped=true"
import script from "./OfficePage.vue?vue&type=script&lang=js"
export * from "./OfficePage.vue?vue&type=script&lang=js"
import style0 from "./OfficePage.vue?vue&type=style&index=0&id=27629eef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27629eef",
  null
  
)

export default component.exports